export const pxToRem = (global: number, fontSize: number): string => {
  return `${fontSize / global}rem`;
};
